import React        from 'react';
import PropTypes    from 'prop-types';
import ReloadHelper from '../../../utils/ReloadHelper';

class ActorLink extends React.Component {
    constructor(props) {
		super(props);
		this.onClick = this.onClickHandler.bind(this);
	}

	/**
	 * @param {Event} e
	 * @returns {*|void}
	 */
	onClickHandler(e) {
		return ReloadHelper.reload(this.props.url, e);
	}

	render() {

		let classSuffix = '';
		if (this.props.specialTile) {
			classSuffix = ' -special';
		}

		if (this.props.url.length === 0) {
			return <span className={"video-grid__item--author" + classSuffix}>{this.props.name}</span>;
		}

		return (
			<a href={this.props.url} className={"video-grid__item--author" + classSuffix} onClick={this.onClick}>
				{this.props.name}
			</a>
		);
	}
}

ActorLink.propTypes = {
	url:         PropTypes.string,
	name:        PropTypes.string.isRequired,
	specialTile: PropTypes.bool,
};

ActorLink.defaultProps = {
	url:         '',
	specialTile: false,
};

export default ActorLink;
